// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__nL2Pe","imageUploader":"EGiftCard_imageUploader__2KN71"};